import { buildThemeCss, loadEventTheme } from '@bizzabo/ai-section-adapter';
import { buildEventThemeUrl } from './remoteSectionUrls';

const PENDING_BLOCK = 'style[data-theme-tokens][data-theme-pending]';

const loads = new WeakMap();

export function ensureThemeTokens(event) {
    const block = document.head.querySelector(PENDING_BLOCK);
    if (!block) {
        return Promise.resolve();
    }
    if (!loads.has(block)) {
        loads.set(block, loadEventTheme(event, { buildThemeUrl: buildEventThemeUrl }).then((theme) => {
            if (theme) {
                block.textContent = buildThemeCss(theme);
            }
            block.removeAttribute('data-theme-pending');
        }));
    }
    return loads.get(block);
}
